module.exports = __webpack_public_path__ + "assets/99b9a93a2ab3d0d66be0699c04a6a175.mp3";